import axios from '../../functions/axios';
import { useState, useEffect, useCallback } from 'react';
import editButton from '../../assets/images/editButton.png';
import { useNavigate } from 'react-router-dom';
import style from './Clients.module.css';
import { useAuthContext } from '../../hooks/useAuthContext';

function ClientsList() {
  const [apiData, setApiData] = useState([]);
  const [overdueInvoiceClients, setOverdueInvoiceClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const getClientsData = async () => {
    if (!user) return null;
    try {
      const { data: response } = await axios.get('/client');
      setApiData(response);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getOverdueInvoiceClients = async () => {
    if (!user) return null;
    try {
      const { data: response } = await axios.get('/overdueInvoiceClients');
      if (response.length > 0) {
        const data = response.map((c) => c.client._id);
        setOverdueInvoiceClients(data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleEditClient = (client) => {
    navigate('/editClient', { state: { client } });
  };

  useEffect(() => {
    getClientsData();
    getOverdueInvoiceClients();
  }, [user]);

  const handleFilterClients = (searchQuery) => setSearchQuery(searchQuery.trim().toLowerCase());

  return (
    <>
      <div className={style.menu}>
        <div className={style.filter}>
          <p>Wyszukaj Klienta:</p>
          <input type='search' className='form-control' placeholder='Imię i nazwisko' onChange={(e) => handleFilterClients(e.target.value)}></input>
        </div>
        <button className='btn btn-default' onClick={navigate.bind(null, '/addClient')}>
          Dodaj Klienta
        </button>
      </div>
      <div className={style.container}>
        {apiData
          .filter((client) => !client.name)
          .filter((client) => {
            if (searchQuery === '') return true;
            return client.companyName.toLowerCase().includes(searchQuery);
          })
          .sort((...args) => {
            const [a, b] = args.map((client) => client.companyName);
            return a.localeCompare(b, 'pl', { sensitivity: 'base' });
          })
          .map((client, index) => {
            const color = (() => {
              if (client.isBlacklisted) return 'black';
              if (overdueInvoiceClients.includes(client._id)) return 'red';
              return '#3d3d3d';
            })();
            return (
              <div key={index} className={style.client} style={{ borderRight: `10px solid ${color}`, outline: '1px solid grey' }}>
                <p className={style.clientName}>{client.companyName}</p>
                <p className={style.clientPhone}>{client.phoneNumber}</p>
                <img className={style.editButton} src={editButton} onClick={handleEditClient.bind(null, client)} alt='edit icon' />
              </div>
            );
          })}
        {apiData
          .filter((client) => client.name)
          .filter((client) => {
            if (searchQuery === '') return true;
            return client.name.toLowerCase().includes(searchQuery);
          })
          .sort((...args) => {
            const [a, b] = args.map((client) => client.name);
            return a.localeCompare(b, 'pl', { sensitivity: 'base' });
          })
          .map((client, index) => (
            <div className={style.client} key={index}>
              <p className={style.clientName}>{client.name}</p>
              <p className={style.clientPhone}>{client.phoneNumber}</p>
              <img className={style.editButton} src={editButton} onClick={handleEditClient.bind(null, client)} />
            </div>
          ))}
      </div>
    </>
  );
}

export default ClientsList;
